import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
export class PieChart {
    /**
     * Takes a serie object and an idChart string or HTMLElement as parameters,
     * and then it sets the type, options, data properties.
     * @param {IChartSeries} serie - IChartSeries
     * @param {IAmchartBase} chart - Chart Object
     */
    constructor(serie, chart) {
        const { title, xAxeId, yAxeId, type, options, data, } = serie;
        this.title = title;
        this.xAxeId = xAxeId;
        this.yAxeId = yAxeId;
        this.chart = chart;
        this.type = type;
        this.options = options;
        this.data = data;
        // Validate that the category type matches before proceeding
        if (!chart.validateTypeChart(this.type))
            throw new Error('Combination of TypeChart is not valid.');
    }
    /**
     * The function creates a series, adds a legend, and then animates the chart.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initSerie(_enableZoom) {
        this.createSeries();
        this.chart.chart.appear(1000, 300);
    }
    /**
     * Create the series of pieChart
     */
    createSeries() {
        var _a, _b;
        // get the pie radius from options
        const radius = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.pieRadius) || 100;
        const innerRadius = ((_b = this.options) === null || _b === void 0 ? void 0 : _b.innerRadius) || 0;
        // Creating a new pie series and pushing it into the chart
        const series = this.chart.chart.series.push(am5percent.PieSeries.new(this.chart.root, {
            name: 'Series',
            categoryField: 'category',
            valueField: 'value',
            alignLabels: true,
            radius: am5.percent(radius),
            innerRadius: am5.percent(innerRadius),
        }));
        if (this.options.tooltipFormat !== undefined) {
            const tooltip = this.chart.generateTooltip(this.options.tooltipFormat, this.yAxeId);
            series.set('tooltip', tooltip);
        }
        if (!this.options.enableTooltip) {
            series.slices.template.set('tooltipText', '');
            series.slices.template.set('alwaysShowTooltip', false);
        }
        if (!this.options.enableLegend && this.options.enableLegend !== undefined) {
            series.labels.template.set('forceHidden', true);
            series.ticks.template.set('forceHidden', true);
        }
        // It's setting the text, color, font size, and font weight of the labels.
        series.labels.template.setAll({
            text: this.options.categoryFormat ? this.options.categoryFormat : '{category}',
            fill: am5.color(0x757575),
            fontSize: 12,
            oversizedBehavior: 'wrap',
            fontWeight: 'normal',
        });
        // It's setting the location of the ticks.
        series.ticks.template.setAll({
            location: 0.9,
        });
        series.slices.template.setAll({
            templateField: 'sliceSettings',
        });
        // It's setting the toggleKey property of the slices template to none.
        series.slices.template.set('toggleKey', 'none');
        this.customizeSlicesColor();
        // Setting the series data
        series.data.setAll(this.data);
        // Animating the series appearance
        series.appear(1000, 300);
        // Saving the series element for later use
        this.seriesElement = series;
    }
    /**
     * Customize the colors of individual slices if exist.
     * If the slices colors are not defined, then use the default values.
     */
    customizeSlicesColor() {
        const newData = [];
        this.data.forEach((slice) => {
            const { color, ...rest } = slice;
            if (!color) {
                newData.push(slice);
            }
            else {
                newData.push({
                    ...rest,
                    sliceSettings: {
                        fill: am5.color(color),
                        stroke: am5.color(color),
                    },
                });
            }
        });
        this.data = newData;
    }
}
//# sourceMappingURL=pieChart.js.map